import React from 'react';
import {
  PiUiErrCodeToErrMsgMapFn,
  PIUIERROR_CODE_RECONSENT,
  PIUIERRCODE_PI_DUPLICATE_USERNAME_SOCIAL,
  PIUIERRCODE_PI_DUPLICATE_USERNAME_SOCIAL_CR,
  PIUIERRCODE_PI_GENERAL_SERVER_ERROR,
  genericSocialErrorMsg,
  genUserAlreadyExistsErrorMsg,
} from '../components/constants';

// type PiErrorKeys = typeof PiUiErrCodeToErrMsgMap;

export function getPiErrorCodeFromAxiosError(error: any) {
  const errorData: PiResponseErrorData = error?.response?.data;
  const errorCode = errorData?.fault?.detail.errorcode || PIUIERRCODE_PI_GENERAL_SERVER_ERROR;

  return errorCode;
}
export function getErrorMessageFromPiErrorCode(PiErrorCode: string) {
  const piError = PiUiErrCodeToErrMsgMapFn(PiErrorCode) || PiUiErrCodeToErrMsgMapFn(PIUIERRCODE_PI_GENERAL_SERVER_ERROR);
  return piError;
}
export function getErrorMessageFromSocialSigninV2Error(error: SocialSigninV2Error) {
  if (!error) {
    return { msg: null, key: null, code: null };
  }

  const piErrorCode = error?.piuiErrorCode || '';
  let msg: string | React.ReactNode;
  let key: string | React.ReactNode;
  let code: string | number | React.ReactNode;
  switch (piErrorCode) {
    case PIUIERRCODE_PI_DUPLICATE_USERNAME_SOCIAL:
    case PIUIERRCODE_PI_DUPLICATE_USERNAME_SOCIAL_CR:
      // msg = PiUiErrCodeToErrMsgMap[piErrorCode].message;
      msg = genUserAlreadyExistsErrorMsg();
      key = 'genUserAlreadyExistsErrorMsg';
      code = null;
      break;
    case PIUIERROR_CODE_RECONSENT:
      msg = PIUIERROR_CODE_RECONSENT;
      key = '';
      code = null;
      break;
    default:
      msg = genericSocialErrorMsg(error?.errorCode || 'I999');
      key = 'genericSocialErrorMsg';
      code = error?.errorCode;
  }
  return { msg, key, code };
}
